import type { ButtonConfig } from '../../declare'
import { toJS } from 'mobx'
import { Popconfirm } from 'antd'
import { EasyIcon } from 'src/components'
import { set } from 'lodash'

type Props = {
  config: ButtonConfig
}

const DeleteConfirmBtn = (props: Props) => {
  const handleDelete = () => {
    const { __CONTEXT__: editTable, __RECORD__: record } = props.config
    const copyData = toJS(editTable.activeTableData?.dataSource || [])
    const findIndex = copyData.findIndex((data: any) => data.ID === record.ID)
    set(copyData[findIndex], 'IS_DELETED', true)
    editTable.activeTable.setDataSource(copyData)
  }

  const { LABEL, ICON } = props.config
  return (
    <Popconfirm
      title='确认删除？'
      onConfirm={handleDelete}
    >
      <span className='color-error'>
        <EasyIcon type={ICON} defaultIcon='DeleteOutlined' className='fz-16' />
        <span className='pd-l4'>{LABEL}</span>
      </span>
    </Popconfirm>
  )
}

export default DeleteConfirmBtn